import {makeAutoObservable} from "mobx";
import AppStore from "../../../app.store";
import axios from "axios";
import {api} from "../../../api/endpoints";
import {toast} from "react-toastify";
import {ClientsLeadQualitiesModel} from "./clients.lead.qualities.model";

const loadingInitialState: boolean = false;
const leadQualitiesInitialState: ClientsLeadQualitiesModel[] = [];

class ClientsLeadQualitiesStore {
    public clientLeadQualities = leadQualitiesInitialState;
    public clientLeadQualitiesLoading = loadingInitialState;
    public deleteLeadQualityLoading = loadingInitialState;
    public setDefaultLeadQualityLoading = loadingInitialState;

    constructor() {
        makeAutoObservable(this)
    }

    private setLoading(loading: boolean) {
        this.clientLeadQualitiesLoading = loading;
    }

    private setLeadQualities(data: any) {
        const {client_lead_qualities} = data;
        this.clientLeadQualities = client_lead_qualities;
    }

    private setDeleteLeadQualityLoading(loading: boolean) {
        this.deleteLeadQualityLoading = loading;
    }

    private setSetDefaultLeadQualityLoading(loading: boolean) {
        this.setDefaultLeadQualityLoading = loading;
    }

    private getHeaders = () => {
        const {getToken} = AppStore;
        return {Authorization: `Bearer ${getToken()}`};
    }

    public clientLeadQualitiesPageInit = async (signal: AbortSignal) => {
        await this.getClientLeadQualitiesReq(signal);
    }

    public getClientLeadQualitiesReq = async (signal?: AbortSignal) => {
        this.setLoading(true);
        const headers = this.getHeaders();

        try {
            const response = await axios.get(api.client_lead_qualities, {headers, signal});
            this.setLeadQualities(response?.data);
            return response;
        } catch (e) {
            console.log(e);
        } finally {
            this.setLoading(false);
        }
    }

    public deleteClientLeadQualityReq = async (leadQualityID: number) => {
        this.setDeleteLeadQualityLoading(true);
        const headers = this.getHeaders();

        try {
            const response = await axios.delete(api.client_lead_qualities + `/${leadQualityID}`, {headers});
            toast.success(response?.data?.message);
            return response;
        } catch (e: any) {
            toast.error(e?.response?.data?.reason);
        } finally {
            this.setDeleteLeadQualityLoading(false);
            await this.getClientLeadQualitiesReq();
        }
    }

    public setDefaultClientLeadQualityReq = async (leadQualityID: number) => {
        this.setSetDefaultLeadQualityLoading(true);
        const headers = this.getHeaders();

        try {
            const response = await axios.put(api.client_lead_qualities + `/default/${leadQualityID}`, {}, {headers});
            toast.success(response?.data?.message);
            return response;
        } catch (e: any) {
            toast.error(e?.response?.data?.reason);
        } finally {
            this.setSetDefaultLeadQualityLoading(false);
            await this.getClientLeadQualitiesReq();
        }
    }
}

export default new ClientsLeadQualitiesStore();